import React, { useEffect, createElement } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { PivotSection } from './components/PivotSection';
import { SolutionSection } from './components/SolutionSection';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { MidPageCTA } from './components/MidPageCTA';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ForWhoSection } from './components/ForWhoSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1438495414738821');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1438495414738821&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-brand-darkGray" data-id="element-0">
      <StickyTopBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProof data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <PivotSection data-id="element-6" />
        <SolutionSection data-id="element-7" />
        <ModulesSection data-id="element-8" />
        <BonusSection data-id="element-9" />
        <MidPageCTA data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <ForWhoSection data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <footer className="bg-brand-darkGray text-gray-400 py-12 text-center text-sm" data-id="element-15">
        <div className="max-w-6xl mx-auto px-4" data-id="element-16">
          <p className="mb-4" data-id="element-17">
            © {new Date().getFullYear()} Mareaa. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-18">
            <a href="#" className="hover:text-white transition-colors" data-id="element-19">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-20">
              Políticas de Privacidad
            </a>
          </div>
        </div>
      </footer>
    </div>;
}